// eslint-disable-next-line

import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import Request from '../../../utils/request';
import TradeUpsFirstStep from '../../pages/TradeUpsFirstStep';
import { GET_TRANSLATIONS } from '../../../config/consts';

import './index.scss';

export function isLocal() {
    return process.env.ENV === 'local';
}

function getLocateCode() {
    const locationArr = isLocal()
        ? ['https:', '', 'www.apc.com', 'shop', 'tradeups', 'us', 'en', 'tradeups', 'overview.jsp']
        : window.location.href.split('/');

    return {
        countryCode: locationArr[5],
        languageCode: locationArr[6],
    };
}
function normalizeTranslations(translationsMap) {
    ['tradeUps_tradeIn25', 'tradeUps_tradeIn35', 'tradeUps_tradeInOrLogin'].forEach(key => {
        translationsMap[key] = translationsMap[key].replace(/\?0/g, '#trade-it');
    });

    translationsMap.tradeUps_tradeInOrLogin = translationsMap.tradeUps_tradeInOrLogin.replace(
        /\?1/,
        window.tradeLoginUrl,
    );
    return translationsMap;
}

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: '',
        };
    }

    getTranslations(location) {
        const { countryCode, languageCode } = location;
        const param = `${languageCode}_${countryCode.toUpperCase()}`;
        const requestOpts = {
            params: {
                locale: param,
                translationsMapName: 'tradeUps',
            },
        };
        Request.get(isLocal() ? '/getTranslations' : GET_TRANSLATIONS, requestOpts)
            .then(result => {
                this.setState({
                    messages: normalizeTranslations(result.translationsMap),
                });
                return result;
            })
            .catch(e => console.error(e));
    }

    componentDidMount() {
        const location = getLocateCode();
        this.getTranslations(location);
    }

    /**
     * Renders component
     * @returns {*}
     */
    render() {
        const { messages } = this.state;
        return (
            <IntlProvider locale="en" messages={messages}>
                <TradeUpsFirstStep />
            </IntlProvider>
        );
    }
}

export default App;
